var React = require('react');

function IconRebateBookmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.109 11.0446L13.8565 7.33901C14.0478 7.14988 14.0478 6.84867 13.8565 6.66654L10.1161 2.96792C10.0028 2.85584 9.8611 2.7998 9.71233 2.7998H0.48172C0.219608 2.7998 0 3.01696 0 3.27614V10.8205C0 11.0306 0.170019 11.1987 0.382543 11.1987H9.7265C9.86818 11.1987 10.0099 11.1427 10.109 11.0446Z"}));
}

IconRebateBookmark.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = IconRebateBookmark;

IconRebateBookmark.default = IconRebateBookmark;
